var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamationTriangleSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "6 7 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.883 7.465c-.348-.62-1.418-.62-1.766 0l-8 14.24a.82.82 0 0 0 .025.885c.181.285.506.41.858.41h16c.351 0 .677-.125.857-.41a.82.82 0 0 0 .026-.885zM15 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2m.748-3.893a.5.5 0 0 1-.5.5h-.487a.5.5 0 0 1-.5-.5L13.75 11.5a.5.5 0 0 1 .5-.5h1.498a.5.5 0 0 1 .5.5z"
})));
export default SvgExclamationTriangleSolid;